import { Controller } from '@hotwired/stimulus'

const SELECTED_CLASSES = ['bg-blue-400', 'text-white', 'border-blue-400']

export default class extends Controller {
  static targets = ['inputsWrapper', 'selectAllButton']

  connect() {
    this.boundSync = this.sync.bind(this)
    this.inputsWrapperTarget.addEventListener('change', this.boundSync)
    this.sync()
  }

  disconnect() {
    this.inputsWrapperTarget.removeEventListener('change', this.boundSync)
  }

  sync() {
    const checkboxes = [...this.inputsWrapperTarget.querySelectorAll('input[type="checkbox"]')]
    const checked = checkboxes.filter((cb) => cb.checked)

    checkboxes.forEach((checkbox) => {
      const label = checkbox.nextElementSibling
      if (!label) return
      if (checkbox.checked) {
        label.classList.add(...SELECTED_CLASSES)
      } else {
        label.classList.remove(...SELECTED_CLASSES)
      }
    })

    const dayInput = this.inputsWrapperTarget.querySelector('input[name="remote_device_action[day]"]')
    if (dayInput) {
      dayInput.value = checked.map((cb) => cb.value).join(':')
    }

    if (!this.hasSelectAllButtonTarget) return

    const allSelected = checkboxes.length > 0 && checked.length === checkboxes.length
    if (allSelected) {
      this.selectAllButtonTarget.classList.add('opacity-60', 'pointer-events-none')
    } else {
      this.selectAllButtonTarget.classList.remove('opacity-60', 'pointer-events-none')
    }
  }
}
